/**
 * @fileoverview GET handler for the "/engagement/segments/can_export_all_attributes" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementSegmentsCanExportAllAttributes } from "./constants";
import type { EngagementSegmentsCanExportAllAttributesResult } from "./types";

export const getEngagementSegmentsCanExportAllAttributes = reactQueryFetcherAdapter(
  engagementSegmentsCanExportAllAttributes,
  (signal: AbortSignal, segmentId: string): Promise<EngagementSegmentsCanExportAllAttributesResult> => {
    return fetch(
      `/engagement/segments/can_export_all_attributes`,
      "GET",
      {
        segment_id: segmentId,
      },
      { signal }
    );
  }
);
